import { html } from 'lit';
import { CircleArrowUp } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-circle-arrow-up')
export class PdsIconCircleArrowUp extends PdsIcon {
  @state()
  icon = CircleArrowUp;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
